import { FC, useEffect, useState } from "react";
import KickImage from 'Reuseables/KickImage';

//Components
import Component from "./Component";

//Actions
import { getTrackingShipper } from "../../../../actions/shipperAction";

//Interfaces
import { WrapperInterface } from "./definitions";

const PackageLocation: FC<WrapperInterface> = ({
  order_id,
  toPickupDetails,
  onHide
}) => {
  const [loading, setLoading] = useState(true);
  const [tracking, setTracking] = useState([])

  const getTrackingHandler = async () => {
    try {
      setLoading(true)
      await getTrackingShipper(order_id)
        .then(res => res?.data)
        .then(res => {
          setTracking(res?.data || [])
        })
        .catch(err => { throw err })
        .finally(() => setLoading(false))
    } catch (err) {
      setLoading(false)
      console.log(err, "Error when get tracking fn getTrackingHandler file PackageLocation.tsx")
    }
  }

  useEffect(() => {
    getTrackingHandler()
  }, [])

  return (<Component
    toPickupDetails={toPickupDetails}
    tracking={tracking}
    loading={loading}
    order_id={order_id}
    onHide={onHide}
    refresh={getTrackingHandler}
  />)
}
PackageLocation.defaultProps = {
  onHide: () => { }
}

export default PackageLocation;